export const ASCENDING = 1;
export const CONTAINS = "contains";
export const CURRENCY = "currency";
export const CURRENCY_LINK = "currency-link";
export const DATE = "date";
export const DATE_LINK = "date-link";
export const DESCENDING = 0;
export const DOES_NOT_CONTAIN = "does-not-contain";
export const NUMBER = "number";
export const NUMBER_LINK = "number-link";
export const PERCENT = "PERCENT";
export const STRING = "string";
export const STRING_LINK = "string-link";
export const UNSORTED = 2;

